import { ReduxRouterState } from '@lagunovsky/redux-react-router';

export enum SearchParamName {
  SymbolPool = 'node',
  SymbolGroup = 'group',
  Search = 'search',
  Server = 'server',
  Stream = 'stream',
  Filter = 'filter',
  ShowUnmapped = 'showUnmapped',
  RuleStatus = 'ruleStatus',
  AlertType = 'type',
  AlertRangeFrom = 'from',
  AlertRangeTo = 'to',
  Sort = 'sort',
}

export interface ISearchParamName {
  name: SearchParamName;
}

export interface ISearchParamNameAndValue extends ISearchParamName {
  value: unknown;
}

export interface IRouterStoreSegment {
  router: ReduxRouterState;
}
